import React from 'react'
import PropTypes from 'prop-types'
import QRCode from 'qrcode.react'
import { Grid, Typography, Box } from '@mui/material'

const ContainerQRCodeTag = ({ containerName, barcodeNumber, containerType }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
      width="100%"
      sx={{ padding: 2 }}
    >
      <Grid container direction="column" spacing={2} alignItems="center">
        <Grid item>
          <Typography variant="h5" align="center">
            <strong>{containerName}</strong>
          </Typography>
          <Typography variant="body1" align="center">
            {containerType}
          </Typography>
        </Grid>

        <Grid item container justifyContent="center" direction="column" alignItems="center">
          {barcodeNumber && <QRCode value={barcodeNumber} size={180} />}
          <Typography variant="body1" align="center">
            {barcodeNumber}
          </Typography>
        </Grid>

        <Grid item container justifyContent="center">
          <img src="/Horiz_Logo.svg" alt="logo" style={{ height: '100px', marginTop: '10px' }} />
        </Grid>
      </Grid>
    </Box>
  )
}

ContainerQRCodeTag.propTypes = {
  containerName: PropTypes.string.isRequired,
  barcodeNumber: PropTypes.string.isRequired,
  containerType: PropTypes.string,
}

ContainerQRCodeTag.defaultProps = {
  containerType: '',
}

export default ContainerQRCodeTag
